import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../../common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from '../../../common/api/emerald-request';

export const login = async (computerName?: string): Promise<string> => {
  const requestConfig: AxiosRequestConfig = {
    url: '/auth/login',
    method: 'POST',
    data: { computerName: computerName || '', domainName: 'corp.ncr.com' },
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: requestConfig,
    addPOSMetaData: false,
    showLoadingComponent: false,
    showLoggingInfo: true,
    spanOptions: { name: 'login' },
  };

  const { sessionId } = await emeraldRequest<ILoginResponse>(emeraldRequestParams);

  return sessionId;
};

interface ILoginResponse {
  sessionId: string;
}
